import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap, map } from "rxjs/operators";

@Injectable()
export class ReferralsService {
  constructor(private http: HttpClientService) {}

  public createBulk(sponsor_id: string | number, emails: string[]): Observable<any> {
    return this.http
      .post("/api/persons/" + sponsor_id + "/referrals", { referral_emails: emails })
      .pipe(tap((_) => console.log("ReferralsService.createBulk: Ok.")));
  }

  public getSponsorId(sponsor_id: string | number): Observable<any> {
    return this.http
      .get("/api/persons/" + sponsor_id + "/referrals")
      .pipe(tap((_) => console.log("ReferralsService.getSponsorId: Ok.")));
  }

  public reinvite(sponsor_id: string | number, email: string): Observable<any> {
    const data = { referral_email: email };
    return this.http
      .post("/api/persons/" + sponsor_id + "/referrals/reinvite", data)
      .pipe(tap((_) => console.log("ReferralsService.reinvite: Ok")));
  }
}
